import React from "react";
import { Toaster as BaseToaster } from "react-hot-toast";

export const Toaster: React.FunctionComponent = () => {
    return (
        <BaseToaster
            position="bottom-left"
            toastOptions={{ duration: 5000, style: { minHeight: 40, maxWidth: 600 } }}
        />
    );
};
